import { Component, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { UserData, PaymentDetails, PaytabsPaymentDetails, PaymentHistory, GeneralBookingModel, requestParam, responseParam } from "../../model/index";
import { ServicePaymentService } from "../../servicepayment/service/servicepayment.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ModalComponent } from "../../shared/modeldialog/index";
import { AdvancePaymentService } from "../service/advancepayment.service";
import { BookingService } from "../../booking/service/booking.service";
declare let Checkout: any;

declare let jspdf: any;
declare let html2canvas: any;
declare let require: any;
declare let MaxWallet: any;
declare let CryptoJS: any;

@Component({
    selector: 'MentisSoft-ServicePayment',
    template: require('../Template/AdvancePayment.template.html'),
    providers: [ServicePaymentService, AdvancePaymentService]
})

export class AdvancePaymentComponent implements AfterViewInit {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    @ViewChild("PopupPayment") PopupPayment: ModalComponent;
    @ViewChild("IsPatientValid") IsPatientValid: ModalComponent;
    loading = false;
    Querynumber: string;
    paytabsPaymentDetails: PaytabsPaymentDetails = new PaytabsPaymentDetails();
    isValid: boolean = false;
    dataSource: PaymentHistory[] = [];
    columns: any[] = [];
    CurrencyValue: string;

    PaymentType: string = "";
    IsPopupPayment: boolean = false;
    IsPatientValidFailed: boolean = false;
    GeneralBookSelected: GeneralBookingModel = new GeneralBookingModel();
    message: string = "";
    Cancelurl: string = "";
    QueryResult: string;
    transactionNo: string = "";
    PayedPayAmount: string = "";
    IsTransaction: boolean = true;
    PaymentErroMsg: string = "";
    IsAmount: boolean = false;
    Remarks: string = "";
    patientId: string = "";
    ReceiptNo: string = "";
    AppNumber: string = "";
    IsProceedPayNow: string = "";
    IsProceedPaybutton: boolean = false;
    HospitalName: string = "";
    requestparamater: requestParam = new requestParam();
    AppointmentComplted: boolean = false;
	tapQuerynumber:string;

    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _titleService: Title, private _paymentService: ServicePaymentService,
        private _servicePaymentService: ServicePaymentService, private _router: Router, private _advancePaymentService: AdvancePaymentService, private _bookingService: BookingService,
        private router: Router) { 
        this.Cancelurl = router.parseUrl(router.url).fragment;
		this.tapQuerynumber = router.parseUrl(router.url).queryParams["tap_id"];
        this.paytabsPaymentDetails.Tap_id  = this.tapQuerynumber;
        this.Querynumber = router.parseUrl(router.url).queryParams["Id"];
        this.paytabsPaymentDetails.AppReqPatientId = this.Querynumber;
        
        this.AppNumber = router.parseUrl(router.url).queryParams["AppNumber"];
        this.paytabsPaymentDetails.AppointmentRquestNo = this.AppNumber;

        this.QueryResult = router.parseUrl(router.url).queryParams["result"];
        if (this.Querynumber == "" || this.Querynumber == undefined) {
            this.Querynumber = this.router.parseUrl(this.router.url).queryParams["result"];
        }
        this.CurrencyValue = localStorage.getItem("CurrencySymbol");
    }

    ngAfterViewInit(): void {
        this.HospitalName = localStorage.getItem("HospitalName");
        $('#overlay').hide();
        this._titleService.setTitle("ServicePayment Reports");
        this.loadPaymentHistoryGrid();  
        if (this.Querynumber != "" && this.Querynumber != undefined && this.QueryResult == "CAPTURED") {
            this.paytabsPaymentDetails.RedirectResult = "CAPTURED";
            this.LoadingAfterPayment(this.Querynumber);
        }
        if (this.Querynumber != "" && this.Querynumber != undefined) {
            if (this.QueryResult != "CAPTURED" && this.QueryResult != "" && this.QueryResult != undefined) {
                this.paytabsPaymentDetails.RedirectResult = this.QueryResult;
                this.LoadingAfterPayment(this.QueryResult);
            }
            else {
                if (this.QueryResult == "" || this.QueryResult == undefined) {
                    this.paytabsPaymentDetails.RedirectResult = this.QueryResult;
                    this.LoadingAfterPayment(this.Querynumber);
                }
            }
        }
        if (this.Querynumber == undefined && this.Cancelurl != "" && this.Cancelurl != "" && this.Cancelurl == "__hc-action-cancel") {
            this.paytabsPaymentDetails.RedirectResult = "CANCEL";
            this.LoadingAfterPayment("CANCEL");
        }
        if (this.Querynumber == "" && this.QueryResult == "") {
            this.paytabsPaymentDetails.RedirectResult = "DENIED+BY+RISK";
            this.LoadingAfterPayment("DENIED+BY+RISK");
        }
		if (this.tapQuerynumber != "" && this.tapQuerynumber != undefined) {
            this.paytabsPaymentDetails.RedirectResult = "TAPPAY";
            //if (this.generalBooking.CaptureData == "CAPTURED")
            //    this.Alertpayment.open();
            this.LoadingAfterPayment("TAPPAY");
        } 
    }

    redirectToPaytabs() {
        this.loading = true;
        if (this.paytabsPaymentDetails.UnitPrice != null && this.paytabsPaymentDetails.UnitPrice != "" && this.paytabsPaymentDetails.UnitPrice != undefined) {
            this.IsAmount = false;

            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            this.paytabsPaymentDetails.ProductsPerTitle = "Advance Payment";
            this.paytabsPaymentDetails.Quantity = "1";
            this.paytabsPaymentDetails.Title = "Advance Payment";
            this.paytabsPaymentDetails.Amount = this.paytabsPaymentDetails.UnitPrice;
            this.paytabsPaymentDetails.Remarks = this.Remarks;
            this.paytabsPaymentDetails.ScreenName = "AdvancePayment";
            localStorage.setItem("AdvancePaymentAmpunt", this.paytabsPaymentDetails.UnitPrice);
            localStorage.setItem("AdvancePaymentRemarks", this.paytabsPaymentDetails.Remarks);
            this.GeneralBookSelected.consultationFee = this.paytabsPaymentDetails.Amount;
            this.GeneralBookSelected.Id = this._SecurityService.pid;
            if ((this.PaymentType != "Y") || (this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "BENEFIT") || (this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "CREDIMAX" && this.paytabsPaymentDetails.buttonActivity == "Payment") || (this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "MAXWALLET" && this.paytabsPaymentDetails.buttonActivity == "Payment")) {
                if ((this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "CREDIMAX" && this.paytabsPaymentDetails.buttonActivity == "Payment") ||(this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "MAXWALLET" && this.paytabsPaymentDetails.buttonActivity == "Payment")) {
                    this._servicePaymentService.ProceedToPayTabs(this.paytabsPaymentDetails, userData)
                        .subscribe(
                        p => {
                            this.loading = false;
                            if (this.paytabsPaymentDetails.PaymentTypeMode == "MAXWALLET") { this.BSHMaxWalletQrCode(); }
                            else {
                                if (p.PaymentRedirectSiteUrl != null && p != null && p.SessionTimeout != "Session Expired") {
                                }
                                else {
                                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                                    this.router.navigate(["/Login"]);
                                }
                            }
                            });}
                else {
                    this._servicePaymentService.ProceedToPayTabs(this.paytabsPaymentDetails, userData)
                        .subscribe(
                        p => {
                            this.loading = false;
                            
                                if (p.PaymentRedirectSiteUrl != null && p != null && p.SessionTimeout != "Session Expired") {
                                    window.location.href = p.PaymentRedirectSiteUrl;
                                }
                                else {
                                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                                    this.router.navigate(["/Login"]);
                                }
                            
                            });
                }
            }
            else {
                this.loading = false;
                if (this.GeneralBookSelected.consultationFee != "0" && this.GeneralBookSelected.consultationFee != "0.00" && this.GeneralBookSelected.consultationFee != undefined && this.GeneralBookSelected.consultationFee != "") {

                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

                    this._bookingService.PaymentModeSelectionGuest(this.GeneralBookSelected, userData)
                        .subscribe(
                            p => {

                                if (p.credimaxPaymentDetails.length != 0 && p.requestParam.length != 0) {
                                    this.GeneralBookSelected.credimaxPaymentDetails = p.credimaxPaymentDetails;
                                    this.GeneralBookSelected.requestParam = p.requestParam;
                                    var secure_hash = this.GeneralBookSelected.requestParam[0].hashedString;
                                    var secretKey = this.GeneralBookSelected.requestParam[0].secretKey;
                                    this.GeneralBookSelected.requestParam[0].secure_hash = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(secure_hash, secretKey));
                                
                                }
                                else {

                                }
                            },
                        err => {
                            console.log("Error while getting department data...");

                            });
                    this.IsPopupPayment = true;
                    this.PopupPayment.open();
                }
                else {
                    this.loading = false;
                    this.IsPatientValidFailed = true;
                    this.IsPatientValid.open();
                    this.message = "Amount should be greater than zero.";
                }
            }
        }
        else {
            this.loading = false;
            this.IsAmount = true;
        }
    }

    LoadingAfterPayment(Querynumber: string) {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        var data = localStorage.getItem("AdvancePaymentAmpunt");
        this.paytabsPaymentDetails.Amount = data;
        this.paytabsPaymentDetails.Remarks = localStorage.getItem("AdvancePaymentRemarks"); 
        
        this._advancePaymentService.AfterPaymentConfirmation(Querynumber, userData, data, this.paytabsPaymentDetails)
            .subscribe(
            s => {
                if (s.SessionTimeout != "Session Expired") {
                    if (s.isValid) {
                        this.loadPaymentHistoryGrid();
                        this.isValid = true;
                        this.transactionNo = s.transaction_id;
                        this.PayedPayAmount = s.PayAmount;
                        this.patientId = s.PatientId;
                        this.ReceiptNo = s.ReceiptNo;
                        this.viewModelPopup.open();
                    }
                    else if (!s.isValid) {
                        this.isValid = false;
                        this.transactionNo = s.transaction_id;
                        if (this.transactionNo == undefined || this.transactionNo == "" || this.transactionNo == "")
                            this.IsTransaction = false;
                        else
                            this.IsTransaction = true;
                        if (s.result == "CAPTURED")
                            this.PaymentErroMsg = "Payment success, we are unable to print the receipt no.  Please contact hospital.";
                        else if (s.result == "NOT+CAPTURED" || s.result == "NOTCAPTURE")
                            this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                        else if (s.result == "HOST+TIMEOUT")
                            this.PaymentErroMsg = "Time out. We are unable to process your payment. Please try again";
                        else if (s.result == "CANCELLED")
                            this.PaymentErroMsg = "Your process has been cancelled. We are unable to process your payment. Please try again";
                        else if (s.result == "DENIED+BY+RISK")
                            this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                        else
                            this.PaymentErroMsg = "We are unable to process your appointment.Please try again";
                        this.viewModelPopup.open();
                    }
                    else {
                        this.viewModelPopup.close();
                    }
                }
                else if(s.SessionTimeout != undefined && s.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                console.log("Error while getting data...");

            });
    }

    keyPress(event: any) {
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    ClosePopup() {
        this.viewModelPopup.close();
        this.router.navigate(["/AdvancePayment"]);
    }

    loadPaymentHistoryGrid() {
        this.loading = true;
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this._advancePaymentService.PaymentHistoryGridDetails(userData)
            .subscribe(
            p => {
                if (p != null && p.SessionTimeout != "Session Expired") {
                    this.loading = false;
                    this.dataSource = p.paymentHistoryListData;
                    this.PaymentType = p.PaymentType;
                    this.IsProceedPayNow = p.IsProceedPayNow;
                    if (p.IsProceedPayNow == "FALSE")
                        this.IsProceedPaybutton = false;
                    else
                        this.IsProceedPaybutton = true;
                    this.buildGrid();
                    this._SecurityService.errorMessage = "";
                }
                else if (p == null || p.SessionTimeout == "Session Expired") {
                    this.loading = false;
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            });
    }

    public buildGrid() {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdPaymentHistory").data("kendoGrid");
            if (dgrid) {
                $('#grdPaymentHistory').data().kendoGrid.destroy();
                $('#grdPaymentHistory').empty();
            }
            jQuery('#grdPaymentHistory').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,              
                columns: this.columns,
                dataBinding: this.databinding,               
                dataSource: {
                    data: this.dataSource,
                    pageSize: this.dataSource != null ? 10 : 0,
                },
            });
            jQuery("#grdPaymentHistory").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdPaymentHistory").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    buildColumn(): void {
        this.columns = [
            {
                field: "ReceiptDate",
                title: "ReceiptDate"
            },
            {
                field: "PaymentDescription",
                title: "PaymentDescription"
            },          
            {
                field: "Amount",
                title: "Amount" + " " + "(" + this.CurrencyValue + ")",
				attributes: {                  
                    "class": "text-right"
                }
            },
            {
                field: "AdjustedAmount",
                title: "AdjustedAmount" + " " + "(" + this.CurrencyValue + ")",
				attributes: {                  
                    "class": "text-right"
                }
            }
        ];
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdPaymentHistory").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {
        }
    }

    PaymentPopupProceed(radioPayment) {
        if (radioPayment != undefined) {
            if (radioPayment == 0) {
                this.paytabsPaymentDetails.PaymentTypeMode = "CREDIMAX";
                this.payCredimaxWithCreditCard();
            }
            else if (radioPayment == 1) {
                this.paytabsPaymentDetails.PaymentTypeMode = "BENEFIT";
            }
            else {
                this.WalletradioClick();
                this.paytabsPaymentDetails.PaymentTypeMode = "MAXWALLET";
                //this.BSHMaxWalletQrCode(); 
            }
        }
        this.paytabsPaymentDetails.buttonActivity = "Payment";
        this.redirectToPaytabs();
        this.PopupPayment.close();
        this.IsPopupPayment = false;
    }

    OnChangeCredit(radioPayment) {
        if (radioPayment != undefined) {
            if (radioPayment == 0) {
                this.GeneralBookSelected.PaymentTypeMode = "CREDIMAX";
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

                this._bookingService.PaymentModeSelectionGuest(this.GeneralBookSelected, userData)
                    .subscribe(
                        p => {
                            if (p.length != 0) {
                                this.paytabsPaymentDetails.credimaxPaymentDetails = p.credimaxPaymentDetails;
                            }
                            else {

                            }
                        },
                    err => {
                        console.log("Error while getting department data...");

                        });
            }
            else {
                this.GeneralBookSelected.PaymentTypeMode = "BENEFIT";
            }
        }
    }
    payCredimaxWithCreditCard() {
        Checkout.configure({
            merchant: this.GeneralBookSelected.credimaxPaymentDetails[0].merchantId,
            order: {
                amount: this.GeneralBookSelected.credimaxPaymentDetails[0].amount,
                currency: this.GeneralBookSelected.credimaxPaymentDetails[0].currency,
                description: this.GeneralBookSelected.credimaxPaymentDetails[0].description,
                id: this.GeneralBookSelected.credimaxPaymentDetails[0].orderId
            },
            session: {
                id: this.GeneralBookSelected.credimaxPaymentDetails[0].sessionId
            },
            interaction: {
                merchant: {
                    name: this.GeneralBookSelected.credimaxPaymentDetails[0].name,
                    address: {
                        line1: 'Manama',
                        line2: 'Manama'
                    }
                }
            }
        });
        Checkout.showPaymentPage();
    }

    private handleError(error: any) {
        console.log("error : " + error);

    }

    makePdf() {
        const div = document.getElementById("Html2Pdf");
        const options = { height: div.clientHeight, width: div.clientWidth };
        html2canvas(div, options).then((canvas) => {
            //Initialize JSPDF
            const doc = new jspdf.jsPDF("p", "mm", "a4");
            //Converting canvas to Image
            const imgData = canvas.toDataURL("image/JPEG");
            //Add image Canvas to PDF
            doc.addImage(imgData, 'JPEG', 30, 30);
            //Name of pdf
            const fileName = "Receipt.pdf";
            // Make file
            doc.save(fileName);
        });
    }


    successCallBack = (result: responseParam): void => {
        console.log(result);
        if (result.errorCode == "200") { this.GeneralBookSelected.CaptureData = "CAPTURED"; }
        this.LoadingAfterPayment("");

    }
    errorCallBack = (result: responseParam): void => {
        console.log(result);
        console.log(this.requestparamater);
        if (result.errorCode == "400") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "401") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "403") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "404") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "412") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "500") { this.GeneralBookSelected.CaptureData = ""; }
        if (result.errorCode == "503") { this.GeneralBookSelected.CaptureData = ""; }
        this.LoadingAfterPayment("");

    }
    closeCallBack = (result: responseParam): void => {
        console.log(this.requestparamater);
        console.log(result);
        this.router.navigate(["/AdvancePayment"]);
    }
    WalletradioClick() {
        //var rere = this.generalBooking.requestParam;
        var secure_hash = this.GeneralBookSelected.requestParam[0].hashedString;
        var secretKey = this.GeneralBookSelected.requestParam[0].secretKey;

        this.requestparamater.merchantId = this.GeneralBookSelected.requestParam[0].merchantId;//"03477850"; 
        this.requestparamater.transactionAmount = this.GeneralBookSelected.requestParam[0].transactionAmount;
        this.requestparamater.transactionCurrency = this.GeneralBookSelected.requestParam[0].transactionCurrency;//"BHD";
        this.requestparamater.hashedString = secure_hash;
        this.requestparamater.appId = this.GeneralBookSelected.requestParam[0].appId;//"3776553556"; 
        this.requestparamater.referenceNumber = this.GeneralBookSelected.requestParam[0].referenceNumber;
        this.requestparamater.secure_hash = this.GeneralBookSelected.requestParam[0].secure_hash; //CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(secure_hash, secretKey));
        this.requestparamater.paymentType = this.GeneralBookSelected.requestParam[0].paymentType;
        this.requestparamater.showResult = this.GeneralBookSelected.requestParam[0].showResult;
        this.requestparamater.lang = this.GeneralBookSelected.requestParam[0].lang;
        console.log(this.requestparamater);
    }
   
    BSHMaxWalletQrCode() {
        console.log(this.requestparamater);
        MaxWallet.open(this.requestparamater, this.successCallBack, this.errorCallBack, this.closeCallBack);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/AdvancePayment/component/advancepayment.component.ts